import { createSelector } from 'reselect';

export const getChainInfos = state => state.SpaceTracing.contactChainInfos;

export const getChainInfo = createSelector(
    getChainInfos,
    (_, spaceNum) => spaceNum,
    (contactChainInfos, spaceNum) => contactChainInfos[spaceNum]
)